import { formatUtcDateTime, isBeforeSupplierDeadline } from './dateUtils';
import type { CancellationPolicy } from './api/types';

export function formatCancellationSummary(policy: CancellationPolicy): string {
  if (!policy.freeCancellationBefore) return 'Non-refundable';
  return `Free cancellation before ${formatUtcDateTime(policy.freeCancellationBefore)}`;
}

export function isFreeCancellation(policy: CancellationPolicy): boolean {
  return policy.freeCancellationBefore !== null;
}

// The supplier's free-cancellation deadline while it is still ahead, otherwise
// null: rates are mapped through this, so a deadline that has already passed
// never reads as "Free cancellation" anywhere downstream.
export function openFreeCancellationBefore(iso: string | null | undefined, now: number = Date.now()): string | null {
  return iso && isBeforeSupplierDeadline(iso, now) ? iso : null;
}
